import React, { ReactNode } from 'react';
import { ErrorInfo } from 'scbk-services/error';

export enum ErrorDisplayType {
    PAGE = 'PAGE',
    POPUP = 'POPUP',
    MODAL = 'MODAL',
    CONFIRM = 'CONFIRM',
    TOAST = 'TOAST',
}

export interface AppErrorOptions extends ErrorOptions {
    code?: string;
    title?: string;
    description?: string;
    errorMessage?: string | React.ReactNode;
    errorGuideMessage?: string[];
    displayType?: ErrorDisplayType;
}

/**
 *
 */
export interface HttpErrorOptions extends AppErrorOptions {
    status?: string;
}

/**
 * 업무 에러
 */
export class AppError extends Error {
    code?: string;
    title?: string;
    description?: string;
    errorMessage?: string | React.ReactNode;
    errorGuideMessage?: string[];
    displayType?: ErrorDisplayType;

    constructor(message = '', options: AppErrorOptions = {}) {
        super(message, { cause: options.cause });

        this.name = 'AppError';
        this.code = options.code ?? 'UNKNOWN';
        this.title = options.title ?? '';
        this.errorMessage = options.errorMessage ?? message;
        this.errorGuideMessage = options.errorGuideMessage ?? [];
        this.description = options.description ?? '';
        this.displayType = options.displayType ?? ErrorDisplayType.PAGE;

        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class RestResponseError extends Error {
    code?: string;
    title?: string;
    description?: string;
    //[2026.04.10] 최성돈 추가
    errorMessage?: string;
    errorGuideMessage?: string;
    errorLocation?: string;

    constructor(code?: string, errorMessage?: string, errorGuideMessage?: string) {
        super(code);
        this.code = code;
        this.title = '';
        this.description = '';
        this.errorMessage = errorMessage;
        this.errorGuideMessage = errorGuideMessage;
    }
}

export interface ErrorPageComponentProps extends ErrorInfo {
    errorCode: string;
    viewType?: 'Component' | 'Page';
    reset?: () => void;
    classNameProps?: string;
    desktopClassName?: string;
    errButtons?: ReactNode;
}

export type ErrorPageComponent = React.ComponentType<ErrorPageComponentProps>;
